import { createReducer, on } from '@ngrx/store';
import { adminActions } from '../actions/admin.actions';
import { Admin } from '../models';

export interface AdminState {
    loaded: boolean | null;
    loading: boolean | null;
    saving: boolean;
    saved: boolean;
    error: number | null;
    admin: Admin | null;
}

export const initialState: AdminState = {
    loaded: null,
    loading: null,
    saving: false,
    saved: false,
    error: null,
    admin: null,
};

export const adminReducer = createReducer(
    initialState,
    // Get
    on(
        adminActions.getAdmin,
        (state): AdminState => ({
            ...state,
            loading: true,
            loaded: null,
            error: null,
        }),
    ),
    on(
        adminActions.getAdminSuccess,
        (state, { payload }): AdminState => ({
            ...state,
            loading: false,
            loaded: true,
            error: null,
            admin: payload,
        }),
    ),
    on(
        adminActions.getAdminError,
        (state, payload): AdminState => ({
            ...state,
            loading: false,
            loaded: false,
            error: payload.code,
        }),
    ),
    // Create
    on(
        adminActions.createAdmin,
        (state): AdminState => ({
            ...state,
            saving: true,
            saved: false,
        }),
    ),
    on(
        adminActions.createAdminSuccess,
        (state, { payload }): AdminState => ({
            ...state,
            saving: false,
            saved: true,
            admin: payload,
        }),
    ),
    on(
        adminActions.createAdminError,
        (state): AdminState => ({
            ...state,
            saving: false,
            saved: false,
        }),
    ),
    // Update
    on(
        adminActions.updateAdmin,
        (state): AdminState => ({
            ...state,
            saving: true,
            saved: false,
        }),
    ),
    on(
        adminActions.updateAdminSuccess,
        (state, { payload }): AdminState => ({
            ...state,
            saving: false,
            saved: true,
            admin: payload,
        }),
    ),
    on(
        adminActions.updateAdminError,
        (state): AdminState => ({
            ...state,
            saving: false,
            saved: false,
        }),
    ),
    // Delete
    on(
        adminActions.deleteAdmin,
        (state): AdminState => ({
            ...state,
            saving: true,
            saved: false,
        }),
    ),
    on(
        adminActions.deleteAdminSuccess,
        (state): AdminState => ({
            ...state,
            saving: false,
            saved: true,
            admin: null,
        }),
    ),
    on(
        adminActions.deleteAdminError,
        (state): AdminState => ({
            ...state,
            saving: false,
            saved: false,
        }),
    ),
    // Clear
    on(adminActions.clear, (): AdminState => ({ ...initialState })),
);
